<template>
  <svg
    :class="svgClass"
    aria-hidden="true"
    v-on="$listeners"
    :style="{width: widthSize, height: heightSize}"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>
<script>
/**
 * svgIcon图标
 * @description 本组件是公共的svg组件的封装
 * @property {String} index 用户传递的标识符值，如果是列表循环，可穿v-for的index值
 * @event {Function} click 头像被点击
 * @example <svg-icon iconClass="process1" widthSize="22px" heightSize="22px" />
 */
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    widthSize: {
      type: String,
      default: '1em'
    },
    heightSize: {
      type: String,
      default: '1em'
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>
<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>